module.exports = __webpack_public_path__ + "static/media/footer-banner.0b1db741.webp";